import { Base64 } from 'js-base64';

class User {
  constructor() {
    this.token = localStorage.getItem('authorization');
    this.identifier = localStorage.getItem('identifier');
    if (!this.identifier) {
      this.setIdentifier(this.uuidv4())
    }
  }

  setIdentifier(identifier) {
    if (!identifier) {
      return;
    }

    localStorage.setItem("identifier", identifier);
    this.identifier = identifier;
  }

  getIdentifier() {
    if (!this.identifier) {
      this.setIdentifier(this.uuidv4())
    }

    return this.identifier;
  }

  setToken(token) {
    if (!token) {
      return;
    }

    localStorage.setItem('authorization', token);
    this.token = token;

    window.dispatchEvent(new Event("userStatusChanged"));
  }

  deleteToken() {
    localStorage.removeItem('authorization');
    this.token = null;

    window.dispatchEvent(new Event("userStatusChanged"));
  }

  signedIn() {
    return this.validToken();
  }

  isGuest() {
    return !this.signedIn();
  }

  validToken() {
    let token = this.token;

    if (!token || token === "") {
      return false;
    }

    let payload = token.split(".")[1];
    if (!payload) {
      return false;
    }

    let data = Base64.fromBase64(payload);
    if (!data) {
      return false;
    }

    data = JSON.parse(data);
    let exp = data['exp'] * 1000;

    return new Date().getTime() < exp;
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export default User;